import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import NetworkIcon from "components/Icons/TobarIcons/NetworkIcon";
import { useAppSelector } from "hooks/store/hooks";
import React from "react";
import { selectCurrentDeviceStatusSettings } from "stores/auth/authSlice";
import { selectColorThemeMode } from "stores/ui/uiSlice";
import { useTranslation } from "TranslationContext";

const NetworkIconDropDown = () => {
  const colorThemeMode = useAppSelector(selectColorThemeMode);
  const { translate } = useTranslation();
  const currentDeviceStatusSettings = useAppSelector(
    selectCurrentDeviceStatusSettings
  );
  const NETWORKICON_DROPDOWN_DATA = [
    {
      key: "operator",
      value: currentDeviceStatusSettings?.device_status?.operator || "",
    },
    {
      key: "cellnumber",
      value: currentDeviceStatusSettings?.device_status?.phonenumber || "",
    },
    {
      key: "imgsinumber",
      value: currentDeviceStatusSettings?.device_status?.serialnum || "",
    },
    {
      key: "mmcmnc",
      value: currentDeviceStatusSettings?.device_status?.mncmcc || "",
    },
    {
      key: "lac",
      value: currentDeviceStatusSettings?.device_status?.lac || "",
    },
    {
      key: "cellid",
      value: currentDeviceStatusSettings?.device_status?.cid || "",
    },
  ];

  return (
    <>
      <Menu
        matchWidth
        isLazy
        lazyBehavior="unmount"
        mb={{ sm: "10px", md: "20px", base: "10px" }}
        p={"10px 0px"}
        h="100%"
        closeOnSelect={false}
      >
        <MenuButton
          as={Button}
          w={{ base: "full", md: "50px" }}
          p={0}
          minW={"0px"}
          h={"50px"}
          borderRadius={"0px"}
          _hover={{ bg: "#00000020" }}
        >
          <Box
            alignItems="center"
            display="flex"
            justifyContent="center"
            gap="1"
          >
            <NetworkIcon />
          </Box>
        </MenuButton>
        <MenuList
          zIndex={1002}
          overflow="hidden"
          right={{ base: "-150px", md: "0px" }}
          position={"absolute"}
          minW={{ base: "250px", md: "300px !important" }}
          maxW={{ base: "250px", md: "300px !important" }}
          borderRadius={"4px"}
          marginTop={"-9px"}
          p={0}
          bg={`${colorThemeMode}_background`}
          boxShadow={"1px 1px 15px rgba(0, 0, 0, .1)"}
        >
          {NETWORKICON_DROPDOWN_DATA  &&
            NETWORKICON_DROPDOWN_DATA?.map((item) => {
              return (
                <MenuItem
                  key={item.key}
                  as={Box}
                  h="50px"
                  bgColor={`${colorThemeMode}_background`}
                  color={`${colorThemeMode}_text`}
                  borderTop={"1px solid"}
                  borderTopColor={`${colorThemeMode}_tertiary`}
                  _hover={{
                    color: `${colorThemeMode}_primary`,
                    bgColor: `${colorThemeMode}_tertiary`,
                  }}
                >
                  <Text fontSize={"16px"} fontWeight={"400"}>
                    {translate[item.key] + " : " + item.value}
                  </Text>
                </MenuItem>
              );
            })}
        </MenuList>
      </Menu>
    </>
  );
};

export default NetworkIconDropDown;